import { Extension } from '@tiptap/react';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { DOMParser as PMMDOMParser } from '@tiptap/pm/model';
import { looksLikeMarkdown, markdownToHtml } from '../utils/markdownUtils';

const MarkdownPaste = Extension.create({
  name: 'markdownPaste',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('markdownPaste'),
        props: {
          handlePaste(view, event) {
            // HTML 클립보드가 있으면 TipTap 기본 처리(서식 유지)에 맡김
            const clipHtml = event.clipboardData?.getData('text/html') || '';
            if (clipHtml) return false;
            const text = event.clipboardData?.getData('text/plain') || '';
            if (!text || !looksLikeMarkdown(text)) return false;

            event.preventDefault();
            const html = markdownToHtml(text);
            const parser = PMMDOMParser.fromSchema(view.state.schema);
            const dom = document.createElement('div');
            dom.innerHTML = html;
            const slice = parser.parseSlice(dom, { preserveWhitespace: false });
            const tr = view.state.tr.replaceSelection(slice);
            view.dispatch(tr.scrollIntoView());
            return true;
          },
        },
      }),
    ];
  },
});

export default MarkdownPaste;
